<div fxLayout="column" fxFlex="grow" style="overflow-y: auto;">
    <div fxLayout="row" fxFlex fxLayoutAlign="start center center" class="modal-header">
        <span fxFlex class="modal-title">Ιστορικό υπενθυμίσεων για την δήλωση {{title}}</span>
        <mat-icon (click)="close()" class="modal-close">close</mat-icon>
    </div>


    <div fxLayout="row" fxFlex="grow">
        <div  fxFlex="grow" fxLayout="column" style="margin-top: 50px; margin-bottom: 20px;" fxLayoutAlign="center center center">
            <mat-table  [dataSource]="records" style="width:100%;">

                <!-- Position Column -->
                <ng-container matColumnDef="action_date">
                    <mat-header-cell fxLayoutAlign="center center center"  *matHeaderCellDef> Ημερομηνία αποστολής </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center center"  *matCellDef="let element"> {{element.action_date}} </mat-cell>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="to">
                    <mat-header-cell fxLayoutAlign="center center center"  *matHeaderCellDef> Παραλήπτες </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center center"  *matCellDef="let element"> {{element.recipients}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell fxLayoutAlign="center center center"  *matHeaderCellDef> Ενέργειες </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center center"  *matCellDef="let element">
                        <button mat-icon-button matTooltip="Εξαγωγή σε excel" (click)="exportToExcel(element)">
                            <mat-icon>download</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <mat-header-row  *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row  *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>

<!--            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>-->
        </div>
    </div>

</div>
